import { createRouter, createWebHistory } from "vue-router"
import type { Component } from "vue"

import MainLayout from "@/layouts/MainLayout.vue"
import HomeDashboard from "@/views/HomeDashboard.vue"
import HomeDashboardIcon from "~icons/heroicons/home"
import LogIn from "@/views/LogIn.vue"

import ChangePassword from "@/views/ChangePassword.vue"
import CustomersIndex from "@/views/CustomersIndex.vue"
import CustomerDetail from "@/views/CustomerDetail.vue"
import CustomerCreate from "@/views/CustomerCreate.vue"
import CustomerEdit from "@/views/CustomerEdit.vue"

import HelpPage from "@/views/HelpPage.vue"

import PaymentsIndex from "@/views/PaymentsIndex.vue"
import PaymentDetail from "@/views/PaymentDetail.vue"
import RequestCreate from "@/views/RequestCreate.vue"

import ServicesIndex from "@/views/ServicesIndex.vue"
import ServiceEdit from "@/views/ServiceEdit.vue"
import ServiceCreate from "@/views/ServiceCreate.vue"

import UsersIndex from "@/views/UsersIndex.vue"
import UserEdit from "@/views/UserEdit.vue"
import UserCreate from "@/views/UserCreate.vue"
import AcceptInvite from "@/views/AcceptInvite.vue"

import TermsAndConditions from "@/views/TermsAndConditions.vue"

declare module "vue-router" {
  interface RouteMeta {
    pageTitle?: string
    icon?: Component
  }
}

const { setPageTitle } = usePageTitle()
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: MainLayout,
      meta: {
        auth: true,
      },
      children: [
        {
          path: "",
          name: "home",
          component: HomeDashboard,
          meta: {
            pageTitle: "Home",
            icon: HomeDashboardIcon,
          },
        },
        {
          path: "payments",
          name: "payments",

          meta: {
            pageTitle: "Payments",
          },
          children: [
            {
              path: "",
              name: "paymentsIndex",
              component: PaymentsIndex,
              meta: {
                pageTitle: "Payments",
              },
            },
            {
              path: "new",
              name: "requestCreate",
              component: RequestCreate,
              meta: {
                pageTitle: "New Request",
              },
              props: ({ query }) => ({
                customerId: query?.customerId,
              }),
            },
            {
              path: ":paymentRequestId",
              props: true,
              name: "paymentDetail",
              component: PaymentDetail,
              meta: {
                pageTitle: "Payment Detail",
              },
            },
          ],
        },
        {
          path: "customers",
          name: "customers",
          children: [
            {
              path: "",
              name: "customersIndex",
              component: CustomersIndex,
              meta: {
                pageTitle: "Customers",
              },
            },
            {
              path: ":customerId",
              name: "customerDetail",
              component: CustomerDetail,
              props: true,
              meta: {
                pageTitle: "Customer Details",
              },
            },
            {
              path: "new",
              name: "customerCreate",
              component: CustomerCreate,
              meta: {
                pageTitle: "New Customer",
              },
            },
            {
              path: ":customerId/edit",
              name: "customerEdit",
              component: CustomerEdit,
              props: true,
              meta: {
                pageTitle: "Edit Customer",
              },
            },
          ],
        },
        {
          path: "staff",
          name: "staff",
          children: [
            {
              path: "",
              name: "usersIndex",
              component: UsersIndex,
              meta: {
                pageTitle: "Staff",
              },
            },
            {
              path: "new",
              name: "userCreate",
              component: UserCreate,
              meta: {
                pageTitle: "New User",
              },
            },
            {
              path: ":userId/edit",
              name: "userEdit",
              component: UserEdit,
              props: true,
              meta: {
                pageTitle: "Edit User",
              },
            },
          ],
        },
        {
          path: "services",
          name: "services",
          children: [
            {
              path: "",
              name: "servicesIndex",
              component: ServicesIndex,
              meta: {
                pageTitle: "Services",
              },
            },
            {
              path: "new",
              name: "serviceCreate",
              component: ServiceCreate,
              meta: {
                pageTitle: "New Service",
              },
            },
            {
              path: ":serviceId/edit",
              name: "serviceEdit",
              component: ServiceEdit,
              props: true,
              meta: {
                pageTitle: "Edit Service",
              },
            },
          ],
        },
        {
          path: "change-password",
          name: "changePassword",
          component: ChangePassword,
          meta: {
            pageTitle: "Change Password",
          },
        },
        {
          path: "help",
          name: "help",
          component: HelpPage,
          meta: {
            pageTitle: "Help",
          },
        },
      ],
    },
    {
      path: "/terms-and-conditions",
      name: "termsAndConditions",
      component: TermsAndConditions,
      meta: {
        pageTitle: "Terms And Conditions",
      },
    },
    {
      path: "/login",
      name: "login",
      component: LogIn,

      meta: {
        pageTitle: "Log In",
      },
    },
    {
      path: "/accept-invite",
      name: "acceptInvite",
      component: AcceptInvite,
      meta: {
        pageTitle: "Create Account",
      },
      props: ({ query }) => ({
        token: query?.token,
      }),
    },
    {
      path: "/:pathMatch(.*)",
      redirect: {
        name: "login",
      },
    },
  ],
})

router.beforeEach((to) => {
  setPageTitle(to.meta.pageTitle || "")
  return true
})

export default router
